import React from 'react';
import Form from 'gatsby-theme-vehicles/src/components/form';
import VehicleContextProvider, { useVehicle } from 'gatsby-theme-vehicles/src/components/vehicle-context';

const RenderForm = () => {
  const {
    strapiId,
    documentId,
    formSlug,
  } = useVehicle();
  return (
    <Form
      vehicleId={documentId || strapiId}
      navigateToAfterSuccess={formSlug}
    />
  );
};

const VehicleModal = ({ vehicle, vdp }) => (
  <VehicleContextProvider
    vehicle={vehicle}
    vdp={vdp}
  >
    <RenderForm />
  </VehicleContextProvider>
);

export default VehicleModal;
